export default {
  label: 'CPF',
  hint: 'Twój bank wymaga CPF do tej płatności. Przekazujemy go dalej i nie przechowujemy.',
  invalid: 'To nieprawidłowy numer CPF. Sprawdź 11 cyfr.',
};
